module.exports = __webpack_public_path__ + "img/45.f18cace1.png";